import '../../node_modules/jquery-once/jquery.once.min';
import './properties';
import './inpage-nav';
import './quote-uploads';
import './quote-info-blocks';
import './header-nav';
import './faq';
import './video-trigger';
import './remove-association';
import './remove-current-coverage';

(function($, Drupal) {
  'use strict';

  /**
   * Resolve issue where clear buttons
   * dont use ajaxon exposed forms using ajax
   */
  Drupal.behaviors.ajaxResetForm = {
    attach: function(context, settings) {
      // only apply to whitelisted views
      // (aleaquo staff dashboard and PM dashboard)
      // to prevent wierdness on other resets
      //
      // hide the reset button if nothing is in input
      // Drupal hides it at first BUT exposes it even
      // if "" is used as the search query
      //
      // all these views have a single exposed search
      let $context = $(context);

      if (
        $context.hasClass('view-aleaquo-staff-dashboard')
        || $context.hasClass('view-property-manager-dashboard')
      ) {
        const $resetBtn = $('[data-drupal-selector=edit-reset]', context);
        const $form = $resetBtn.closest('form');
        const $input = $form.find('[data-drupal-selector=edit-combine]');
        const $submitBtn = $form.find('[type=submit]');

        // called when this behavior is attached
        // so we can see if it has been cleared
        if ($input.val() === '') {
          $resetBtn.hide();
        }
        else {
          $resetBtn.show();
        }

        $resetBtn.click(function(e) {
          e.preventDefault();
          // clear the combined input
          $input.val('');
          // get both submits (includes the reset)
          // click the first (real submit) since it actually does ajax
          $submitBtn.eq(0).trigger('click');
        });
      }
    }
  };

  /**
   * Adds functionality for Aleaquo users that changes focus to
   * exposed search input when landing on the Dashboard page
   */
  Drupal.behaviors.auDashboardForceFocus = {
    attach: function(context, settings) {
      let auDashboardId = '#views-exposed-form-aleaquo-staff-dashboard-aleaquo-staff-dashboard-associations-block';

      $(auDashboardId, context)
        .once('auDashboardForceFocus')
        .each(function() {
          $(this).find('#edit-combine').focus();
        });
    }
  };

  /**
   * Adds functionality for Property Management users that changes focus to
   * exposed search input when landing on the Dashboard page
   */
  Drupal.behaviors.pmuDashboardForceFocus = {
    attach: function(context, settings) {
      let pmuDashboardId = '#views-exposed-form-property-manager-dashboard-associations';

      $(pmuDashboardId, context)
        .once('pmuDashboardForceFocus')
        .each(function() {
          $(this).find('#edit-combine').focus();
        });
    }
  };

})(jQuery, Drupal);
